import { EnumLike } from '@sona/shared-model-common';

/**
 * Enum representing the different appearances of a card
 */
export enum CardAppearance {
    /**
     * A card with a grey background
     */
    SOLID = 'solid',
    /**
     * A card with a box shadow
     */
    RAISED = 'raised',
    /**
     * A card with a solid border
     */
    OUTLINE = 'outline'
}

export type CardAppearanceType = EnumLike<CardAppearance>;
